import {
  RequestQuotationBody,
  SupplierDetail,
  SupplierDetailResponse,
  SupplierResponse,
} from "./models/SupplierModel";

export const GetAllSupplierList = async (): Promise<SupplierResponse> => {
  const response = await fetch("api/Supplier/SupplierList", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
  return response as SupplierResponse;
};

export const SendRequestQuotation = async (
  dataJson: RequestQuotationBody
): Promise<SupplierResponse> => {
  const response = await fetch("api/Supplier/SendRequestQuotation", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataJson),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response as SupplierResponse;
};

export const GetSellerById = async (
  sellerId: number
): Promise<SupplierResponse> => {
  const response = await fetch(
    `api/Supplier/GetSellerById?SellerID=${sellerId}`
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response as SupplierResponse;
};

export const getSellerByEmpCode = async (
  empCode: string
): Promise<SupplierDetailResponse> => {
  const response = await fetch(`api/Supplier/GetSellerByEmpCode/${empCode}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return response as SupplierDetailResponse;
};

export const requestOTPAndSaveToDb = async (request: { TelMobile: string }) => {
  const response = await fetch(`api/Supplier/OTP/RequestAndSave`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const verityOTP = async (request: {
  TelMobile: string;
  Ref_Code: string;
  OTP: string;
}) => {
  const response = await fetch(`api/Supplier/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  })
    .then((res) => res.json())
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
